import React from 'react'
import { Text, Box, Container, Heading, useColorMode, Flex, Tag } from '@chakra-ui/react'
import '../css/About.css'
import { motion } from 'framer-motion';
import TimeLine from './TimeLine';

export default function About() {
  const { colorMode } = useColorMode()
  const isDark = colorMode === 'dark'

  return (
    <Box id='about' p={10}>
      <Container maxW='container.lg' pt={14} pb={16}>
        <motion.div
          whileInView={{opacity: [0, 1]}}
          transition={{ duration: 0.5}}
        >
        <Heading as='h2' size='lg' noOfLines={1} pb={10}>About me</Heading>
        <Container pb={8} pt={8} maxW='container.sm' centerContent>
          <Text fontSize='lg'>
          Hi there! 
          <br />
          I'm a web designer and frontend developer based in Argentina with a passion from building beautiful and functional web applications.
          <br />
          Beyond front-end development, I'm also a Full Stack dev. So, if you need help putting together an application or API with Node.js and Express or PostgresSQL, then I've got your back.
          <br />
          </Text>
        </Container> 
        <Heading as='h4' size='md' noOfLines={1} pt={10} pb={12}>Bio</Heading>
        <TimeLine isDark={isDark} />
      </motion.div>
      </Container>
    </Box>
  )
}
